module.exports = __webpack_public_path__ + "static/media/fiter-toggle.9b6b6922.svg";